import axios from '../utils/axios';

export default function bulkDeactivateRecruiters (adminId, data) {
    return axios.post(`/admin/${adminId}/recruiter-bulk-deactivate`, data);
};